//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngSimpleClock', srsngSimpleClock);

    function srsngSimpleClock() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/simple-clock/simple-clock.html',
            scope: {},
            controller: controller
        };

        function controller(
            CONTAINER_DATEFORMATS,
            $filter,
            $element) {

            refreshClock();
                
            function refreshClock() {
                let newDate = $filter('date')(new Date(), CONTAINER_DATEFORMATS.WITHTIMEANDSECONDS, '+0000');
                $element.find('.date').html(newDate);
                setTimeout(refreshClock, 1000);
            }

        }
    }
})();